import type { Store } from 'effector'
import { and, not } from 'patronum'

import { hasDigitOrSpecialCharacter, hasLower, hasUpper } from '@portal/lib/password-requirement'

import { env } from '@/shared/config'

type Options = {
    $password: Store<string>
}

export function createPasswordValidation({ $password }: Options) {
    const $passwordLongEnough = $password.map((password) => password.length >= env.ACCOUNT_PASSWORD_MIN_LEN)
    const $isPasswordShort = not($passwordLongEnough)

    const $passwordHasLowerAndUppercase = $password.map(
        (password) => hasUpper.test(password) && hasLower.test(password)
    )

    const $passwordHasDigitOrSpecialCharacter = $password.map((password) => hasDigitOrSpecialCharacter.test(password))

    const $isPasswordWeak = not(
        and($passwordLongEnough, $passwordHasLowerAndUppercase, $passwordHasDigitOrSpecialCharacter)
    )

    return {
        $passwordLongEnough,
        $isPasswordShort,
        $passwordHasLowerAndUppercase,
        $passwordHasDigitOrSpecialCharacter,
        $isPasswordWeak,
    }
}
